import React from "react";
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from "../ReportsV2/styles";
import { PointText, StyledModal } from "../../components/RewardsManagement/Rewards/styles"
import { commaSeperator } from "../../utils/methods";


const CongratulationPopup = ({
  show,
  modalWidth = "373px",
  modalHeight = "252px",
  companyInfo,
  onCancel,
  SpotPointsEarned,
  UserName
  //   history,
}) =>{

  //   const [loading, setLoading] = useState(false);

  window.console.log('companyInfo', companyInfo);
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight} style={{zIndex:9999}}  >
      <div className="headingText">
         Congratulations {UserName}!
      </div>
      <PointText isMargin={"20px"}>You Received +{commaSeperator(SpotPointsEarned)} Spot Points From Your Organization for your great teamwork Keep <br/> it up! </PointText>
      <PointText>Working together toward shared goals through collaboration and trust.</PointText>
      <div className='footer'>
        <CommonButtonPopup height="44px" width="341px"  onClick={onCancel}>
         Thank You!
        </CommonButtonPopup>
      </div>
    </StyledModal>
  )};


CongratulationPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  onCancel: PropTypes.func,
  SpotPointsEarned: PropTypes.number,
  UserName: PropTypes.string,
};

export default withRouter((CongratulationPopup));
  
